import React, { createContext, useState, useContext, useEffect } from 'react';
import { translations } from './translations';
import type { Language, LanguageContextType } from './types';

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

// Aman di iframe sandbox/opaque (embed LP): akses storage bisa ditolak browser.
const readLang = (): Language => {
    try {
        const saved = localStorage.getItem('app_language');
        return (saved === 'en' || saved === 'id') ? saved : 'id';
    } catch { return 'id'; }
};

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [language, setLanguageState] = useState<Language>(readLang);

    useEffect(() => {
        try { localStorage.setItem('app_language', language); } catch { /* iframe sandbox: abaikan */ }
    }, [language]);

    const setLanguage = (lang: Language) => {
        setLanguageState(lang);
    };

    const t = (key: string): string => {
        const keys = key.split('.');
        let value: any = translations[language];

        for (const k of keys) {
            if (value && typeof value === 'object' && k in value) {
                value = value[k];
            } else {
                return key; // Return key if translation not found
            }
        }

        return typeof value === 'string' ? value : key;
    };

    return (
        <LanguageContext.Provider value={{ language, setLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};
